import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Authorization } from "../../../Context/Authorization";
import Table from "react-bootstrap/Table";
import Preloader from "../../../shared/PreLoaders";

const CircleMemberPage = () => {
  const { circleId } = useParams();
  const [divisionData, setDivisionData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const Api = process.env.REACT_APP_API;
  const [circleName, setCircleName] = useState("");

  const LOCAL_KEY = `CircleMemberDataCache_${circleId}`;
  const [summary, setSummary] = useState({});
  const saveToLocalCache = (circleName, divisionList, summary) => {
    localStorage.setItem(
      LOCAL_KEY,
      JSON.stringify({
        circleName,
        divisionList,
        summary, // ✅ store summary
        timestamp: new Date().toISOString(),
      })
    );
  };

  const loadFromLocalCache = () => {
    const cached = localStorage.getItem(LOCAL_KEY);
    return cached ? JSON.parse(cached) : null;
  };

  const fetchDivisionData = async () => {
    try {
      const config = Authorization();
      const res = await axios.get(
        `${Api}/api/drill/circle-vfc/${circleId}`,
        config
      );
      setCircleName(res.data.circleName);
      setDivisionData(res.data.data);
      saveToLocalCache(res.data.circleName, res.data.data, res.data.summary);
      setSummary(res.data.summary);
    } catch (error) {
      console.error("Error fetching division-wise VFC data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);

    const cached = loadFromLocalCache();

    if (cached && cached.divisionList) {
      setCircleName(cached.circleName || ""); // Restore name
      setDivisionData(cached.divisionList);
      setSummary(cached.summary || {}); // defensive
      setLoading(false);
    } else {
      fetchDivisionData();
    }
  }, [Api]);
  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
  };
  if (loading) return <Preloader loading={true} />;
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            >
              ← Back
            </li>
            <li
              className="breadcrumb-item active"
              style={{
                color: "red",
                cursor: "pointer",
              }}
              onClick={() => navigate("/dashboard")}
            >
              🏠 Home
            </li>
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(+1)}
            >
              → Previous
            </li>
          </ol>
        </nav>
      </div>
      {!loading && (
        <div className="d-flex justify-content-between align-items-center mb-3 px-2">
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => {
              localStorage.removeItem(LOCAL_KEY);
              setLoading(true);
              fetchDivisionData();
            }}
          >
            🔄 Refresh Now
          </button>

          <div className="text-muted small">
            Last Refreshed:{" "}
            {loadFromLocalCache()?.timestamp
              ? formatDateTime(loadFromLocalCache().timestamp)
              : "Not Available"}
          </div>
        </div>
      )}
      <div
        className="col-md-12 stretch-card grid-margin"
        style={{ cursor: "pointer" }}
      >
        <div className="card bg-gradient-RainforestMist card-img-holder text-white">
          <div className="card-body">
            <img
              src={require("../../../../assets/images/dashboard/circle.png")}
              className="card-img-absolute"
              alt="circle"
            />
            <h4 className="font-weight-normal mb-3">{circleName} Circle</h4>
            <h1>
              {(summary?.totalCircleMembers || 0).toLocaleString("en-IN")} -
              Member's
            </h1>
          </div>
        </div>
      </div>

      <h4 className="mb-3">Division-wise VFC Summary</h4>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Division Name</th>
            <th className="text-center">Total Range's</th>
            {/* <th className="text-center">Total VFC's</th> */}
            <th className="text-center">Total Member's</th>
            <th className="text-center">Male</th>
            <th className="text-center">Female</th>
            <th className="text-center">Third Gender</th>
          </tr>
        </thead>
        <tbody>
          {divisionData
            .sort((a, b) => a.divisionName.localeCompare(b.divisionName))
            .map((division, index) => (
              <tr key={division.divisionId}>
                <td className="text-center">{index + 1}</td>
                <td
                  className="text-start"
                  style={{
                    color: "blue",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={() =>
                    navigate(`/drill/division-member/${division.divisionId}`)
                  }
                >
                  {division.divisionName}
                </td>
                <td className="text-center">{division.rangeCount}</td>
                {/* <td className="text-center">
                  {division.vfcCount.toLocaleString("en-IN")}
                </td> */}
                <td className="text-center">
                  {division.totalMembers.toLocaleString("en-IN")}
                </td>
                <td className="text-center">
                  {division.totalMales.toLocaleString("en-IN")}
                </td>
                <td className="text-center">
                  {division.totalFemales.toLocaleString("en-IN")}
                </td>
                <td className="text-center">
                  {division.totalOthers.toLocaleString("en-IN")}
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );
};

export default CircleMemberPage;
